import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

export default class ProjectCountPortal extends React.Component {
  static propTypes = {
    count: PropTypes.number
  };

  render() {
    const domNode = document.getElementById('project-leads-count');

    if (domNode) {
      return createPortal(
        this.renderText(),
        domNode
      );
    } else {
      return null;
    }
  }

  renderText() {
    const { count } = this.props;
    if (count == null) return null;

    return <span>({count})</span>;
  }
}
